import React, { createContext, useContext, useState } from "react";
import { ActionItem } from "../../models/SKChannel";

// Define the context type
interface UpdateListContextType {
  updateList: (channelId: string, actionType: ActionItem) => void;
  setUpdateListFunction: React.Dispatch<React.SetStateAction<(channelId: string, actionType: ActionItem) => void>>;
}

// Create the context with a default value of `null`
const UpdateListContext = createContext<UpdateListContextType | null>(null);

// Hook to access the context
export const useUpdateList = (): UpdateListContextType => {
  const context = useContext(UpdateListContext);
  if (!context) {
    throw new Error("useUpdateList must be used within an UpdateListProvider");
  }
  return context;
};

// Provider component to wrap the app
export const UpdateListProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // State to hold the updateList function
  const [updateList, setUpdateListFunction] = useState<(channelId: string, actionType: ActionItem) => void>(() => () => {});

  return <UpdateListContext.Provider value={{ updateList, setUpdateListFunction }}>{children}</UpdateListContext.Provider>;
};
